<template>
  <div id="app">
    <vue-snotify></vue-snotify>
    <navigation-component/>
    <div :id="navID">
    </div>
    <router-view/>
  </div>
</template>

<script>
  import NavigationComponent from '@/components/Navigation'

  export default{
    name: 'App',
    components: {
      'navigation-component': NavigationComponent
    },
    computed: {
      onContentViewer: function(){
        return this.$route.name == "contentViewer"
      },
      navID: function(){
        if(this.onContentViewer){
          return "nav-no-display"
        }
        else{
          return "nav"
        }
      }
    }
  }
</script>
<style lang="scss">

// // Import Bulma's core
@import "~bulma/sass/utilities/_all";



// Set colors
$twitter: #4099FF;
$twitter-invert: findColorInvert($twitter);
// $danger: #E4241B;
$danger: #7F1E27;
$primary: #EEEEEE;
$primary-invert: findColorInvert($primary);
$success: #1E7F27;
$success-invert: findColorInvert($success);
$nav-bar: #7E807E;
$nav-bar-invert: findColorInvert($nav-bar);
$background: #ffffff;
$background-invert: findColorInvert($background);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "twitter": ($twitter, $twitter-invert),
    "nav-bar": ($nav-bar, $nav-bar-invert),
    "background": ($background, $background-invert)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";


#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  background-color: $primary;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
#nav-no-display{
  display: none;
}
.view{
  margin-top: 54px;
  padding-top: 2rem;
  padding-bottom: 2rem;
  background-color: #f7f7f7;
}

body,html{
    color: #4a4a4a;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    background-color: $primary !important;
    height: 100%;
}

footer {
    
    padding: 1rem 0;
}

.snotify {
    width: auto !important;
}
.card-container {
  background-color: #FFFFFF;
  border-radius: 15px;
  padding: 1rem 1rem 1rem 1rem;
  margin: 20px 20px 20px 20px;
  -webkit-box-shadow: 0px 10px 20px -8px rgba(0,0,0,0.15);
  -moz-box-shadow: 0px 10px 20px -8px rgba(0,0,0,0.15);
  box-shadow: 0px 10px 20px -8px rgba(0,0,0,0.15);
}

.is-success{
  background-color: $success !important;
}

.child-view {
  transition: all .5s cubic-bezier(.55,0,.1,1);
  left: 0;
  width: 100%;
}
.slide-left-enter, .slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}
.slide-left-leave-active, .slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}
.footerLink{
  color: white;
}
.footerLink:hover, .footer:visited, .footer:active{
  color: #317D9B;
}
</style>
